<template>
    <div class="the-map relative">
        <div class="the-map-back faa-fade faa-opti" :class="{ 'faa-fade-in': show }">
            <img src="@/assets/images/map.svg" @load="mapLoaded">
        </div>

        <TheMapOverlay :show="show" />
        
        <TheMapSound />
    </div>
</template>

<script>
    import TheMapOverlay from '@/components/map/TheMapOverlay'
    import TheMapSound from '@/components/map/TheMapSound'

    export default {
        name: 'TheMap',
        components: {
            TheMapOverlay,
            TheMapSound
        },
        data() {
            return {
                show: false,
            }
        },
        methods: {
            mapLoaded() {
                setTimeout(() => {
                    this.show = true
                }, 500);
            },
        },
    }
</script>

<style lang="scss" scoped>

.the-map {
    img, svg {
        @apply h-full w-full;
    }

    .the-map-back {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

</style>
